import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { Pricing } from "@/components/site/Pricing";
import { PRICING } from "@/data/pageCopy";


const { kicker, h1Lines, lead, faq, cta } = PRICING;
const faqs = faq.items;

export default function PricingPage() {
  return (
    <div data-testid="pricing-page">
      <section className="relative pt-32 md:pt-40 pb-6 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }} />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-5">{kicker}</p></Reveal>
          <h1 className="font-heading font-medium tracking-tight leading-[0.98] text-4xl md:text-6xl text-white max-w-3xl">
            <MaskedLines lines={h1Lines} delay={0.1} />
          </h1>
          <Reveal delay={0.35}>
            <p className="mt-7 text-lg text-neutral-400 max-w-xl leading-relaxed">
              {lead}
            </p>
          </Reveal>
        </div>
      </section>

      <Pricing />

      <section className="py-20 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl text-white mb-10">{faq.h2}</h2></Reveal>
          <div className="border border-white/10 bg-white/[0.02]">
            {faqs.map((f, i) => (
              <Reveal key={f.q} delay={(i % 4) * 0.05}>
                <div className="px-7 py-6 border-b border-white/10 last:border-0">
                  <h3 className="font-heading font-semibold text-lg text-white">{f.q}</h3>
                  <p className="mt-2 text-neutral-400 text-sm leading-relaxed max-w-3xl">{f.a}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0a0a0a] text-white">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl max-w-xl">{cta}</h2>
          <Link to="/demo" className="group inline-flex items-center gap-2 bg-white text-black font-bold px-7 py-4 hover:bg-neutral-200 transition-colors shrink-0">
            Talk to us <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Link>
        </div>
      </section>
    </div>
  );
}
